import { URL_PATH } from "../services/API";

export const getUserLocation = async (
  successCallback = (obj) => console.log("Success Callback:", obj),
  errorCallback = (err) => console.log("Error Callback:", err)
) => {
  if (!navigator.geolocation) {
    console.warn("Geolocation not supported by this browser.");
    errorCallback({ message: "Geolocation not supported" });
    return;
  }

  console.log("➡️ Attempting to get user location...");

  navigator.geolocation.getCurrentPosition(
    async (position) => {
      const { latitude, longitude, accuracy } = position.coords;

      console.log("✅ Location obtained:");
      console.log("Latitude:", latitude);
      console.log("Longitude:", longitude);
      console.log("Accuracy (meters):", accuracy);

      try {
        // Replace this with your actual backend or third-party endpoint
        const result = await window.axios.get(
          URL_PATH.latLangToAddress(latitude, longitude)
        );

        successCallback({
          ...result.data,
          lat: latitude,
          lng: longitude,
          accuracy,
        });
      } catch (err) {
        console.error("❌ Failed to fetch address from coordinates:", err);
        errorCallback(err);
      }
    },
    (error) => {
      console.error("❌ Geolocation error:", error);
      errorCallback(error);
    },
    {
      enableHighAccuracy: true,  // Try to get the most accurate position
      timeout: 15000,            // Max wait time
      maximumAge: 0              // Always try to get a fresh location
    }
  );
};



let success_coords = {
    coords: {
        latitude: 51.4554803,
        longitude: -2.0843058,
        altitude: null,
        accuracy: 49,
        altitudeAccuracy: null,
        heading: null,
        speed: null,
    },
    timestamp: 1583860898576,
};
